import { render } from "./attributesDetail.vue?vue&type=template&id=18c1f4d5"
import script from "./attributesDetail.vue?vue&type=script&lang=js"
export * from "./attributesDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__